import axios from 'services/axios'
import { clearTermsAcknowledged } from 'components/TermsAndConditionsModal/utils'

const logoutRequest = () => axios.get('auth/logout')

export const handleLogout = () => {
    clearTermsAcknowledged()
    logoutRequest().then(res => {
        window.location.href = `${res.data.logoutUrl}?id_token_hint=${res.data.idToken}&post_logout_redirect_uri=${window.location.origin}`
    })
}
